import { render } from "./CalendarEventSection.vue?vue&type=template&id=7b5ee1d5"
import script from "./CalendarEventSection.vue?vue&type=script&lang=js"
export * from "./CalendarEventSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__